import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import { Divider, Tab, Tabs } from '@mui/material';
import { AppContext } from '@/AppContext';
import { Route, useParams } from 'react-router-dom';

import DeskList from '../DeskList/DeskList';
import Chat from '../Chat/Chat';
import OnlineRegistration from '../OnlineRegistration/OnlineRegistration';

const PREFIX = 'VisitorRegistration';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(3),
  },
}));

const VisitorRegistration = () => {
  const appContext = useContext(AppContext);
  const { mid: meetupId } = useParams();

  const valueFromUrl = () => {
    const path = appContext.history.location.pathname;
    if (path.indexOf('desk') !== -1) {
      return 'desk';
    }
    if (path.indexOf('online-registration') !== -1) {
      return 'onlineRegistration';
    }
    return '';
  };

  return (
    <Root className={classes.root}>
      <Tabs
        onChange={() => {}}
        scrollButtons='auto'
        value={valueFromUrl()}
        variant='scrollable'
        style={{ margin: 'auto', maxWidth: 'max-content' }}
      >
        <Tab
          label={'Онлайн'}
          value={'onlineRegistration'}
          onClick={() => {
            appContext.history.push('/m/' + meetupId + '/online-registration');
          }}
        />
        <Tab
          label={'Офлайн'}
          value={'desk'}
          onClick={() => {
            appContext.history.push('/m/' + meetupId + '/desk');
          }}
        />
      </Tabs>
      <Divider />
      <Route path='/m/:mid/desk'>
        <DeskList />
      </Route>
      <Route path='/m/:mid/online-registration'>
        <OnlineRegistration />
      </Route>
    </Root>
  );
};

export default VisitorRegistration;
